/**
 * Pre-Pipeline Hook
 *
 * Standard extensibility point that runs FIRST in every pipeline.
 * Currently a pass-through, but can be subclassed or configured for:
 * - Cross-cutting concerns (auth, metrics, enrichment)
 * - Pre-processing before any other hooks
 * - Pipeline initialization logic
 *
 * Always has priority 1 (runs before all other hooks).
 */

import { BaseHook } from './base/BaseHook';
import type { IPipelineContext, HookResult } from '../types';

export class PrePipelineHook extends BaseHook {
  readonly name = 'PrePipelineHook';
  readonly priority = 1; // Always first

  async execute(_context: IPipelineContext): Promise<HookResult> {
    // Pass-through by default. Override in subclass for custom logic.
    return this.continue();
  }
}
